import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Headline } from 'components/Headline';

const Title = styled(Headline)`
  padding: 1.5rem;
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;

  min-width: 60rem;
  padding: 1.5rem;

  border-top: 0.1rem solid ${pickColor('borderSemiLight')};
  border-bottom: 0.1rem solid ${pickColor('borderSemiLight')};
`;

const Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 1.5rem;

  padding: 1.5rem;
`;

const Content = styled.div``;

export { Title, Wrapper, Actions, Content };
